import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import InfoIcon from "@material-ui/icons/Info";

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(-0.65),
    //minWidth: 110,
  },
  iconForm: {
    spacing: 4,
    paddingLeft: 6,
    fontSize: 16,
  },
}));

function PATHCheckbox(props) {
  const [checked, setChecked] = React.useState(false);
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
    props.handler(event);
    //
    //
  };

  const open = Boolean(anchorEl);
  return (
    <div>
      <FormControlLabel
        className={classes.formControl}
        //labelPlacement="start"

        control={
          <Checkbox
            checked={props.checkedVal}
            disabled={props.disabled}
            //onChange={(e)=>setChecked(e.target.checked)}
            onChange={handleChange}
            className={classes.formControl}
            inputProps={{
              "aria-label": "secondary checkbox",
            }}
            p={2}
          />
        }
        label={props.nameVal}
      />
      <InfoIcon
        className={classes.iconForm}
        fontSize="inherit"
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      />
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography>{props.description}</Typography>
      </Popover>
    </div>
  );
}

export default PATHCheckbox;
